<template>
  <div>
    <h1>Editar plano</h1>
    <b-card no-body>
      <Form @saved="loadData" />
    </b-card>
  </div>
</template>

<script>
import Form from "../Components/Form.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Form },
  computed: {
    ...mapState("planos", ["plano"]),
  },
  methods: {
    ...mapActions("planos", ["ActionNewplano", "ActionShow"]),
    async loadData(id) {
      try {
        await this.ActionShow(id);
      } catch (error) {
        this.$notifications.addNotification({
          message: error.data.responseMessage,
          icon: "exclamation-triangle",
          type: "danger",
        });
        this.$router.push({ name: "planos_list" });
      }
    },
  },
  async created() {
    this.ActionNewplano();
    await this.loadData(this.$route.params.id);
  },
};
</script>

<style></style>
